import api, { METHODS } from './api'

export default async function getCustomSendSmtpDelay(): Promise<number> {
    try {
        const customSendSmtpDelay = await api<{customSendDelay: number}>(
            `customSendSmtpDelay`, // for apache servers
            METHODS.GET
        )

        return customSendSmtpDelay.customSendDelay
    } catch (error) {
        // TODO: use logger
        // console.error(error)
        console.error("Could not get the current setted SMTP delay between sends in reports-maker", error)
        
        return -1
    }
}